<!--
 * @Description: 提交材料
 * @Date: 2025-09-12 17:45:57
-->
<template>
  <BaseTextTitle>提交材料</BaseTextTitle>
  <BaseTextContent>
    <BaseForm label-position="top" disabled :model="formData" :column-count="4">
      <BaseFormItem
        label="所属园区"
        prop="businessParkName"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.businessParkName"
        />
      </BaseFormItem>
      <BaseFormItem label="补充说明" prop="additionalRemark">
        <BaseInput
          style="width: 100%"
          type="textarea"
          placeholder="请输入"
          :rows="3"
          v-model="formData.additionalRemark"
        />
      </BaseFormItem>
      <BaseFormItem label="个体户意向名" prop="intentNameList">
        <BaseInput
          style="width: 100%"
          type="textarea"
          placeholder="请输入"
          :rows="3"
          :model-value="formData.intentNameList.join('、')"
        />
      </BaseFormItem>
      <BaseFormItem label="其他材料" prop="fileList">
        <BaseUpload
          v-if="!formData.isSkipFile"
          style="width: 100%"
          listType="text"
          btnText="添加文件"
          autoUpload
          showFileList
          disabled
          :accept="['.jpg', '.jpeg', '.png', '.pdf', '.bmp']"
          :limit="0"
          :limitSize="2"
          :multiple="false"
          :uploadBtnProps="{
            limitOverHide: true
          }"
          v-model:fileList="formData.fileList"
          @preview="onFilePreview"
        />
        <BaseInput
          v-else
          disabled
          type="textarea"
          style="width: 100%"
          placeholder="请输入"
          model-value="线下提供材料"
        />
      </BaseFormItem>
    </BaseForm>
  </BaseTextContent>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';

const formData = defineModel<IndividualInfoDetailData & { fileList: any[] }>();

const onFilePreview = v => {
  window.open(v.url);
};
</script>
